<template>
  <svg
    width="24"
    height="24"
    fill="none"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M4 10V14M4 10L17.5 6.75V17.25L4 14"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />

    <path
      d="M9.25 15.05L10 17.05C10.16 17.48 10.57 17.75 11.03 17.75H12.45C12.9 17.75 13.3 17.48 13.47 17.06L13.95 15.75"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>